import '../styles/_loader.scss';

const LoadingSpinner = ({isLoading}) => {
    return (
        <>
            { isLoading &&
                <div className="loader-container" id="loader">
                    <div className="loader"></div>
                </div>
            }
        </>
    );
};

export default LoadingSpinner;
